import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup,  ReactiveFormsModule,  Validators } from '@angular/forms';
import { MatModule } from '../appModules/mat.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ExportService } from '../shared/services/exportservice';

@Component({
  selector: 'app-course-master',
  imports: [CommonModule,ReactiveFormsModule,MatModule,MatPaginatorModule],
  templateUrl: './course-master.component.html',
  styleUrl: './course-master.component.scss'
})
export class CourseMasterComponent {
  dataSource: any = new MatTableDataSource([]);
  displayedColumns: any = {
   label: ['sno','name','course_short_form','crs_code','createdAt'],
   cols: ['sno','name','course_short_form','crs_code','createdAt']
  }
  pagination = {
    length: 0,
    page: 1,
    limit: 5,
  };
  currentPage=0;
 //currentindex=1;
 formGroup: FormGroup;
 isLoading = false;

 CourseId: string | null = null;
 
 isCourseList=false;

 constructor(
   private fb: FormBuilder,
   private api: ApiService,
   private common: CommonService,
   private exportService: ExportService
 ) {
   this.formGroup = this.fb.group({
     name: ['', [Validators.required]],
     crs_code: ['', [Validators.required]],
     course_short_form:['',[Validators.required]]
   });
 }

 ngOnInit(): void {
  
   this.getCourseList();
 }

 getCourseList_download(): void {
  this.api.get(`settings/getCourseList`).subscribe({
    next: (response) => {
    
      if (response && response.data && response.data.length > 0) {

        this.dataSource = response.data;
        this.pagination.length = response?.totalCount || 0;
        const exportPayload = {
          filename: 'course-list',
          displayedColumns: this.displayedColumns.cols,
          data: this.dataSource,
          dateField:['createdAt'],
          isDateMultiply:false
        };
        this.exportService.exportExcel(exportPayload);
      } else {
        console.log('No settings found or empty settings array');
      }
      this.isLoading = false;
    },
    error: (error) => {
      console.error('Error fetching settings information:', error);
      this.common.notification('Error loading settings information', true);
      this.isLoading = false;
    }
  });
}

 getCourseList(): void {
   this.isCourseList=true;
   this.isLoading = true;

   const queryParam: any = [];
   queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
   this.api.get(`settings/getCourseList?${queryParam.join('&')}`).subscribe({
     next: (response) => {
     
       if (response && response.data && response.data.length > 0) {

         this.dataSource = response.data;
         this.pagination.length = response?.totalCount || 0;
       } else {
         console.log('No settings found or empty settings array');
       }
       this.isLoading = false;
     },
     error: (error) => {
       console.error('Error fetching settings information:', error);
       this.common.notification('Error loading settings information', true);
       this.isLoading = false;
     }
   });
 }
 
 resetForm(): void {
   this.isCourseList=false;
   this.formGroup.reset();
  
 }


isEdit=false;
 edit(row:any){
   this.isCourseList=false;   
   this.CourseId=row.id;
   this.isEdit=true;
   this.formGroup.patchValue({
     name: row.name,
     crs_code: row.crs_code,
     course_short_form:row.course_short_form,
   });
 }
   


 saveCourse(): void {
   this.isCourseList=false;
   if (this.formGroup.invalid) {
    this.common.notification('Please fill all required information', true);
     return;
   }

   this.isLoading = true; 
   let formData =  this.formGroup.value;
   if (this.CourseId) {
        
     this.api.put(`settings/updateCourse/${this.CourseId}`, formData).subscribe({
       next: (response) => {
         
         this.common.notification(response.message);
         this.isLoading = false;
       },
       error: (error) => {
         console.error('Error updating settings information. Full error:', error);
         this.isLoading = false;
       }
       
     });
     this.resetForm();
   } else {
    this.api.post(`settings/addCourse`,formData,true).subscribe({
       next: (response) => {
        if (response.status) {
           this.common.notification(response.message);
           this.isLoading = false;
         }else{
         this.common.notification(response.message);
        }
         this.isLoading = false;
       },
       error: (error) => {
         this.common.notification(`Error saving razorpay: ${error.message || 'Unknown error'}`, true);
         this.isLoading = false;
       }
     });
     this.getCourseList();
     this.resetForm();
   }
 }
 



 addCourse(){
   this.resetForm();
   this.isCourseList=false;
 }
 


back(){
 this.isEdit=false;
 this.isCourseList=true;  
 this.resetForm();
 this.CourseId=null;
 this.getCourseList();
}

delete(row:any)
{

 const courseId=row.id;
 this.api.put(`settings/deleteCourse/${courseId}`,'').subscribe((resp:any)=>{
   if(resp.status){
     this.common.notification(resp.message);
   }else{
     this.common.notification("unable to delete");
   }
   this.getCourseList();

 });
}

pageEvent(e: any) {
  this.isLoading = false;
 
  this.pagination.page = e.pageIndex + 1;
  this.pagination.limit = e.pageSize;
  this.currentPage = e.pageIndex * e.pageSize;
  this.getCourseList();
}
}